import * as React from "react"
import type { SVGProps } from "react"
const SvgPersonAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M18.5 11h-2a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71A1 1 0 0 1 16.5 9h2V7q0-.42.29-.71A1 1 0 0 1 19.5 6q.42 0 .71.29.3.29.29.71v2h2q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29h-2v2q0 .42-.29.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71zm-9 1q-1.65 0-2.82-1.17Q5.5 9.65 5.5 8c0-1.65.4-2.04 1.18-2.82Q7.85 4 9.5 4c1.65 0 2.04.4 2.83 1.18Q13.5 6.35 13.5 8c0 1.65-.4 2.04-1.17 2.83A4 4 0 0 1 9.5 12m-8 6v-.8q0-.86.44-1.56.44-.72 1.16-1.09a15 15 0 0 1 3.15-1.16A14 14 0 0 1 9.5 13a14 14 0 0 1 6.4 1.55q.72.37 1.16 1.09.45.71.44 1.56v.8q0 .83-.59 1.41a2 2 0 0 1-1.41.59h-12q-.82 0-1.41-.59A2 2 0 0 1 1.5 18m2 0h12v-.8a1 1 0 0 0-.5-.85q-1.35-.68-2.72-1.01a11.6 11.6 0 0 0-5.55 0q-1.38.33-2.73 1.01a1 1 0 0 0-.5.85zm6-8q.82 0 1.41-.59.6-.58.59-1.41 0-.82-.59-1.41A2 2 0 0 0 9.5 6q-.82 0-1.41.59A2 2 0 0 0 7.5 8q0 .82.59 1.41.58.6 1.41.59" />
  </svg>
)
export default SvgPersonAdd
